import { useTLang } from 'intl/intl';

export function useCardCustomizationLang() {
  return {
    item: {
      title: useTLang({ id: 'menuPage.global.option' }),
    },
  };
}
